import useAuth from './useAuth';

/**
 * Custom hook to check if division ID exists in assigned divisions
 * @param {string|number} divisionId - Division ID to check
 * @returns {boolean} - True if division exists, false otherwise
 */
export const useIsDivisionAssigned = (divisionId) => {
  const { user } = useAuth();
  if (!user?.assignedDivisions || !divisionId) {
    return false;
  }

  return user.assignedDivisions.some(
    (division) => division.id === divisionId || division === divisionId
  );
};
